import type {Checkout} from '@wix/ambassador-checkout/types'
import type {CreateCartResponse} from '@wix/ambassador-ecom-v2-cart/types'
import type {Order} from '@wix/ambassador-ep-orders/types'

export const isFreeCheckout = (checkout: Checkout) => {
  return Number(checkout.priceSummary!.total!.amount) === 0
}

export const isFreeOrder = (order: Order) => {
  return Number(order.priceSummary!.total!.amount) === 0
}

const isPositiveAmount = (amount?: string) => Number(amount ?? 0) > 0

export const isCartPaymentRequired = (cartResponse: CreateCartResponse) => {
  return isPositiveAmount(cartResponse.cart?.subtotal?.amount)
}
